export default __webpack_public_path__ + "static/media/rocket b.dc67477b.png";